import React from 'react'
import Avatar from '@mui/material/Avatar';


function Category(props) {
  return (
    <div className='flex justify-center m-4 mt-[40px] mt-[40px]'>
      <div
      style={{background:`${props.gray?'#F7F7F7':'#FFFFFF'}`}} 
      className='m-1 p-1 w-full md:w-5/6 flex flex-1 flex-wrap rounded-lg md:m-2 md:p-2 justify-evenly items-center'>
          {<Avatar alt="logo" sx={{ height: '100px', width: '100px' }} src={props.logo} />}
          <div className='text-2xl'>
            <div>{props.top}</div>
            <div className='text-xl'>{props.middle}</div>
            <div className='text-xl'> {props.end}</div>
            {props.isimg&&<div><div className='text-xl'>{props.final}</div><div className='text-xl'>{props.finally}</div></div>}
          </div>
      </div>
    </div>
  )
}

export default Category
